export const DEFAULT_MAX_BATCH_SIZE = 10;
export const DEFAULT_MAX_RETRIES = 5;
export const FLUSH_INTERVAL_MS = 500;
export const BASE_DELAY_MS = 10000;
export const OBSERVABILITY_API_ENDPOINT = '/api/log';
export const noop = () => {};